// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__li8pA","container":"style_container__26IDj","wrapper":"style_wrapper__BWTIN","title":"style_title__2af5P","content":"style_content__5RJK4"};